import { useEffect } from 'react';
import { apiGet } from '@/api/_base';

const VISIT_KEY = 'hg.visit-tracked';

export function VisitTracker() {
  useEffect(() => {
    if (sessionStorage.getItem(VISIT_KEY)) return;
    sessionStorage.setItem(VISIT_KEY, '1');
    apiGet('/api/v1/visits').catch(() => {});
  }, []);

  return null;
}
